// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"ba4d01a9","271":"99e46132","399":"33ed9a7c","451":"0c130a9b","546":"1efec240","646":"d39f1d3d","740":"aa22f27d","753":"c5c29c0b","787":"3761a192","861":"37df86b2","952":"3f585447","992":"8a1b74bb"}[chunkId] + ".chunk.js";
};